
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hiring-solutions",
      function () {
        return require("private-next-pages/hiring-solutions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hiring-solutions"])
      });
    }
  